import { render, staticRenderFns } from "./writeoff.vue?vue&type=template&id=4513007e&scoped=true&"
import script from "./writeoff.vue?vue&type=script&lang=js&"
export * from "./writeoff.vue?vue&type=script&lang=js&"
import style0 from "./writeoff.vue?vue&type=style&index=0&id=4513007e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4513007e",
  null
  
)

/* custom blocks */
import block0 from "./writeoff.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports